<style lang="scss">
    :focus{
        outline:0;
    }
    div.flex-lr {
        display: flex;
        flex-direction: row;
        background: #fff;
        margin-top: 15px;
        .el-tree {
            border: 1px solid #E4E7ED;
            margin-right: 15px;
            overflow-y: auto;
        }
        .el-cascader-panel {
            margin: 15px;
        }
        .el-scrollbar {
            overflow: hidden auto;
        }
        .el-cascader-menu__wrap {
            height: auto;
            overflow: hidden;
        }
        .my-table-block {
            margin: 0;
            height: unset;
            overflow-x: hidden;
        }
    }
</style>
<template>
    <div id="app">
        <login v-if="$store.state.pageType === pageType.LOGIN"></login>
        <master v-else></master>
    </div>
</template>

<script>
    import variable from '@/util/variable'
    import Master from './pages/Master';
    import Login from './pages/auth/Login';

    export default {
        name: 'app',
        components: {
            Master,
            Login,
        },
        data() {
            return {
                pageType: variable.pageType,
            }
        },
    }
</script>
